import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const adminApi = () => {
    const token = localStorage.getItem("ss_admin_token") || "";
    return axios.create({
        baseURL: API,
        headers: { "Content-Type": "application/json", "X-Admin-Token": token },
    });
};

export const formatEUR = (n) =>
    new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(Number(n || 0));
